module.exports = __webpack_public_path__ + "img/Ballon_latex.4f65475.jpg";